import React, { Fragment } from "react";
import {
  Button,
  createStyles,
  Grid,
  Hidden,
  makeStyles,
  Paper,
  Tooltip,
  Fab,
  Card,
  CardHeader,
} from "@material-ui/core";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { confirm } from "../../components/ConfirmationDialog/ConfirmationDialog";
import { AntTab, AntTabs } from "../../components/TabPanel/TabPanel";
import OrderStore from "../../Store/OrderStore";
import {
  ListPanel,
  ListPanelLoading,
  PanelExport,
} from "./Container/ListPanel";

import Link from "@material-ui/core/Link";

import InputSearch from "../../components/InputSearch/InputSearch";
import { submitFormPromoTenant } from "./Container/FormPromoTenant";
import { Add } from "@material-ui/icons";

import promotionStore from "../../Store/PromotionStore";

import ArrowForwardRounded from "@material-ui/icons/ArrowForwardRounded";
import moment from "moment";

// import list promo tenant
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
// import Paper from '@material-ui/core/Paper';

import { showDetail } from "./Container/DetailTenant";

import tenantStore from "../../Store/TenantStore";
import { Skeleton } from "@material-ui/lab";
import PropertyService from "../../Services/PropertyService/index";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: "100%",
    },
    paper1: {
      marginTop: 15,
      backgroundColor: theme.palette.background.paper,
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    buttonDownload: {
      border: "0",
      cursor: "pointer",
      backgroundColor: "transparent",
    },
    table: {
      minWidth: 650,
    },
  })
);

const ListPromoTenant = (props) => {
  const { dataTenant, dataKey, showDetail } = props;
  const user = JSON.parse(localStorage.getItem("user"));
  const userTenantId = user.tenant.id;
  return (
    <TableRow key={dataTenant.id}>
      <TableCell component="th" scope="row">
        {dataKey}
      </TableCell>
      <TableCell component="th" scope="row">
        {dataTenant.title}
      </TableCell>
      <TableCell component="th" scope="row">
        <Link
          onClick={showDetail}
          style={{ cursor: "pointer", color: "#1E88E5" }}
        >
          {dataTenant.property && dataTenant.property.name}
          {" - "}
          {dataTenant.tenant && dataTenant.tenant.name}
        </Link>
      </TableCell>
      <TableCell component="th" scope="row">
        {moment(dataTenant.start_time).format("DD/MM/YYYY") || "-"}
      </TableCell>
      <TableCell component="th" scope="row">
        {moment(dataTenant.end_time).format("DD/MM/YYYY") || "-"}
      </TableCell>
      <TableCell component="th" scope="row">
        <Link
          onClick={showDetail}
          style={{ cursor: "pointer", color: "#1E88E5" }}
        >
          <ArrowForwardRounded />
        </Link>
      </TableCell>
    </TableRow>
  );
};

// end list promo tenant

const PromoTenant = (props) => {
  const classes = useStyles();
  const [tabActive, setTabActive] = React.useState(0);
  const [expanded, setExpanded] = React.useState(false);
  const [orderState, orderActions] = OrderStore();
  const prevTabActive = usePreviousTab(tabActive);

  const user = JSON.parse(localStorage.getItem("user"));
  const userTenant = user.tenant.id;

  const [tenant, setTenant] = React.useState(user.tenant?.id);

  const [search, setSearch] = React.useState("");
  const [componentWillmount, setComponentWillMount] = React.useState(false);

  let arrProcess = [
    { label: "Request" },
    { label: "Approve", deleted: false, approved: true },
    { label: "Reject", deleted: true, approved: false },
  ];

  let perPage = 10;

  const handleTabChange = (event, newTab) => {
    setExpanded(false);
    setTabActive(newTab);
  };

  function usePreviousTab(value) {
    const ref = React.useRef();
    React.useEffect(() => {
      ref.current = value;
    });

    return ref.current;
  }

  const handleGetList = async (refresh) => {
    let newDataProperty = "";
    const res = await PropertyService.getList({
      num: 10,
      operational_level: user?.operational?.level,
      level: user?.operational?.level < 3 ? user?.operational?.level - 1 : "",
      cursor: "",
      parent_id: user?.operational?.level < 3 ? user?.operational?.id : "",
      type: "",
    });
    console.log(res.data.id);
    // console.log("^^^^^");

    res.data.map((e) => {
      // return e.id
      newDataProperty += e.id + ",";
    });

    const tabRefresh =
      refresh === false && tabActive === prevTabActive ? false : true;
    refresh = user?.type === "staff" ? tabRefresh : refresh;
    var query = {
      num: perPage.toString(),
      cursor: !refresh ? promotionState.header["x-cursor"] : "",
      position: "",
      deleted: arrProcess[tabActive].deleted === true ? "true" : "false",
      approved: arrProcess[tabActive].approved === true ? "true" : "false",
      keyword: search,
      type: "tenant",
      property_id: newDataProperty.slice(0, newDataProperty.length - 1) || "",
    };
    // if (tenant > 0) {
    // 	query.tenant_id = tenant;
    // } else {
    // 	query.tenant_id = "";
    // }

    promotionActions.getTenant(query, refresh);
  };

  const handleActions = (value) => {
    if (value) {
      submitFormPromoTenant("Update Promotion Tenant", value).then(
        (onProcess) => {},
        (onCancel) => {
          handleGetList(true);
        }
      );
    } else {
      submitFormPromoTenant("Create Promotion Tenant", null).then(
        (onProcess) => {},
        (onCancel) => {
          handleGetList(true);
        }
      );
    }
  };

  const [promotionState, promotionActions] = promotionStore();

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      handleGetList(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, [tabActive, search]);

  const handleDetailMenu = (value) => {
    let deleted = arrProcess[tabActive].deleted;
    let approved = arrProcess[tabActive].approved;
    let tabShow = arrProcess[tabActive].label;
    showDetail(
      "Detail Promotion",
      value,
      deleted,
      approved,
      tabShow,
      props.params,
      handleGetList
    ).then(
      (process) => {
        handleActions(value);
      },
      (cancel) => {
        // setUpdate(!update);
      }
    );
  };

  return (
    <BaseLayout>
      <Fragment>
        <Grid container style={{ padding: 5, marginBottom: 10 }}>
          <Grid
            container
            item
            xs={10}
            direction="row"
            alignItems="flex-end"
            justify="flex-start"
          >
            {" "}
            <h3>Promotion / Promo Tenant</h3>
          </Grid>
          <Grid
            container
            item
            xs={10}
            direction="row"
            alignItems="flex-end"
            justify="flex-start"
          >
            <InputSearch
              value={search}
              onChange={(e) => {
                handleSearch(e);
              }}
              placeholder="Search Promotion / Tenant"
            />
          </Grid>
          <Grid container item xs={2} justify="flex-end" alignItems="flex-end">
            <Hidden xsDown implementation="css">
              {props.params.create && (
                <Tooltip
                  title="add users"
                  aria-label="add"
                  arrow
                  placement="bottom"
                >
                  <Fab
                    onClick={() => handleActions(null)}
                    color="secondary"
                    variant="extended"
                    aria-label="add"
                    style={{
                      marginRight: "10px",
                      borderRadius: 0,
                      padding: "0 30px",
                    }}
                  >
                    <Add /> Add{" "}
                  </Fab>
                </Tooltip>
              )}
            </Hidden>
          </Grid>
        </Grid>

        {/* end */}
        <Grid container className={classes.root}>
          {userTenant == "0" && (
            <Grid item xs={12}>
              <AntTabs
                value={tabActive}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
              >
                {arrProcess.map((process, index) => {
                  return <AntTab key={index} label={process.label}></AntTab>;
                })}
              </AntTabs>
            </Grid>
          )}

          {userTenant != "0" && (
            <Grid item xs={12}>
              <AntTabs
                value={tabActive}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
              >
                {arrProcess.map((process, index) => {
                  return (
                    <AntTab
                      key={index}
                      label={
                        process.label == "Reject" ? "Remove" : process.label
                      }
                    ></AntTab>
                  );
                })}
              </AntTabs>
            </Grid>
          )}

          <Grid item xs={12}>
            <TableContainer>
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>No</TableCell>
                    <TableCell align="left">Title</TableCell>
                    <TableCell align="left">Mall &amp; Tenant</TableCell>
                    <TableCell align="left">Start Date</TableCell>
                    <TableCell align="left">End Date</TableCell>
                    <TableCell align="left">&nbsp;</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {promotionState.data.length > 0 &&
                    !promotionState.refresh &&
                    promotionState.data.map((value, key) => {
                      return (
                        <ListPromoTenant
                          key={value.id}
                          dataTenant={value}
                          dataKey={key + 1}
                          doEdit={() => handleActions(value)}
                          showDetail={() => handleDetailMenu(value)}
                        />
                      );
                    })}
                  {promotionState.isLoading &&
                    Array.from(new Array(perPage)).map((value, key) => {
                      return (
                        <TableRow key={key}>
                          <TableCell component="th" scope="row">
                            <Skeleton height={14} />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton height={14} />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton height={14} />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton height={14} />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton height={14} />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Skeleton height={20} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          {!promotionState.isLoading && promotionState.data.length === 0 && (
            <Grid item xs={12}>
              <div className={classes.demo1}>
                <Grid
                  item
                  xs
                  container
                  justify="center"
                  style={{ margin: 10, padding: 12 }}
                >
                  <span>No Data</span>
                </Grid>
              </div>
            </Grid>
          )}
          {promotionState.data.length >= perPage - 1 && (
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              style={{ padding: "10px" }}
            >
              {promotionState.lastPage ? (
                <h2>~</h2>
              ) : (
                <Button
                  onClick={() => handleGetList(false)}
                  size="small"
                  color="secondary"
                  variant="contained"
                  disabled={promotionState.isLoading}
                >
                  {promotionState.isLoading ? "Please Wait" : "Load More"}
                </Button>
              )}
            </Grid>
          )}
          {!promotionState.isLoading && (
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              style={{ padding: "10px" }}
            ></Grid>
          )}
        </Grid>
        <div className=" d-flex justify-content-end">
          <Hidden smUp implementation="css">
            {props.params.create && (
              <Tooltip
                title="add reservation"
                aria-label="add"
                arrow
                placement="left"
              >
                <Fab
                  aria-label="Add"
                  classes={{ root: "FabMobile" }}
                  className={classes.fab}
                  color="primary"
                  onClick={() => handleActions(null)}
                >
                  <Add />
                </Fab>
              </Tooltip>
            )}
          </Hidden>
        </div>
      </Fragment>
    </BaseLayout>
  );
};

export default PromoTenant;
